import { ErrorType } from "../../../models/HttpError";
import { Settlement } from "../../../models/Entities/Settlements/Settlement";
import { SettlementResume } from "../../../models/Entities/SettlementResume/SettlementResume";

// stores
import * as SettlementResumeStore from '../../../redux/middleware/SettlementResumeMiddleware';
import * as SettlementsStore from '../../../redux/middleware/SettlementMiddleware';

//State
import { AppState } from "../../../redux/reducers";

interface IProps {
    isOpen: boolean;
    openPanel: () => void;
    dismissPanel: () => void;
    SettlementId: number;
    SettlementResumeId?: number;
}
  
interface ConnectedProps {
    // isAdding: boolean;
    // isSuccessfullyAdded: boolean;
    // failOnAdding: boolean;
    // isUpdating: boolean;
    // isSuccessfullyUpdated: boolean;
    // failOnUpdating: boolean;
    // error: ErrorType | undefined;
    Settlement: Settlement | undefined;
    SettlementResume: SettlementResume | undefined;
}

interface SettlementDispatchProps {
    //AddSettlementResume: typeof SettlementResumeStore.actionCreators.AddSettlementResume;
    //UpdateSettlementResume: typeof SettlementResumeStore.actionCreators.UpdateSettlementResume;
}

export type Props = IProps & ConnectedProps & SettlementDispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {

    return {
        // //adding
        // isAdding: state.SettlementResume?.isAddingNewOne,
        // isSuccessfullyAdded: state.SettlementResume?.successAddingNewOne,
        // failOnAdding: state.SettlementResume?.failOnAddingNewOne,
        
        // // updating
        // isUpdating: state.SettlementResume?.isUpdatingOne,
        // isSuccessfullyUpdated: state.SettlementResume?.successUpdatingOne,
        // failOnUpdating: state.SettlementResume?.failOnUpdatingOne,

        // error: state.SettlementResume?.error,
        
        Settlement: state.Settlement?.list?.find((settlement: Settlement) => settlement.id === ownProps.SettlementId ),
        SettlementResume: state.Settlement?.list?.find((settlement: Settlement) => settlement.id === ownProps.SettlementId )?.resumes?.find((settlementResume: SettlementResume) => settlementResume.id === ownProps.SettlementResumeId ) 
    }
};

export const mapDispatchToProps = {
  ...SettlementResumeStore.actionCreators,
  ...SettlementsStore.actionCreators
};


// styles 
